class MultiSelect {

    multiSelects: NodeListOf<HTMLSelectElement>;
    tagBtns: NodeListOf<HTMLAnchorElement>;

    constructor(){
        this.init();
    }

    init(){
        this.multiSelects = document.querySelectorAll('select.multi');
        
        if(this.multiSelects.length > 0){
            
            this.multiSelects.forEach(select => {
                let selectedFilters = [];
                select.addEventListener('change', (e) => {
                    //<a href="#" class="tag me-2 my-1">Information Sessions</a>
                    if(!selectedFilters.includes(select.value)){
                        selectedFilters.push(select.value);
                        this.renderTag(selectedFilters, select.id);
                    }
                })
                document.addEventListener('click', (e) => {
                    let thisBtn = e.target as HTMLAnchorElement;
                    if(thisBtn.classList.contains('tag')){
                        const selectId = thisBtn.parentElement.id.replace("Selects", "");
                        if(selectedFilters.includes(thisBtn.dataset.tag)){
                            selectedFilters = selectedFilters.filter((filter) =>{
                                return filter !== thisBtn.dataset.tag;
                            })
                            this.renderTag(selectedFilters, selectId);
                        }
                    }
                })
            })

            
        }
    }

    renderTag(tags, id) {
        const tagWrapper: HTMLDivElement = document.querySelector('#' + id + 'Selects');
        if(tagWrapper != null){
            tagWrapper.innerHTML = "";
            tags.forEach(tag => {
                let newTag = document.createElement('a');
                newTag.classList.add('tag', 'me-2', 'my-1');
                newTag.setAttribute('data-tag', tag);
                newTag.id = 'tag' + tag.replaceAll(' ', '');
                newTag.innerHTML = tag + ' <ion-icon class="close-outline" name="close-outline"></ion-icon>';
                tagWrapper.appendChild(newTag);
            })

            if(tags.length > 0){
                tagWrapper.classList.remove('d-none');
            } else {
                tagWrapper.classList.add('d-none');
            }
        } 
    }
}

export default MultiSelect;